import { Flex, Typography } from 'antd';
import PropTypes from 'prop-types';
import { getHarnessError } from '../utils/harness';

const titles = {
  pending: '准备更新',
  pulling: '准备版本',
  running: '更新中',
  completed: '更新完成',
  failed: '更新失败',
};
const HarnessUpgradeFeedback = ({ upgrade }) => {
  if (!upgrade) return <Typography.Text type="secondary">暂无更新记录</Typography.Text>;
  const { progress } = upgrade;
  return (
    <Flex vertical gap="small">
      <Flex gap="middle" wrap>
        <Typography.Text aria-label="版本更新状态">{titles[upgrade.status]}</Typography.Text>
        {upgrade.target?.tag && <Typography.Text>目标版本：{upgrade.target.tag}</Typography.Text>}
        {progress && (
          <Typography.Text>
            共 {progress.total} 个实例，已完成 {progress.completed}，处理中 {progress.pending}
            ，失败 {progress.failed}
            {progress.removed > 0 ? `，已移除 ${progress.removed}` : ''}
          </Typography.Text>
        )}
      </Flex>
      {upgrade.error && (
        <Typography.Text type="danger">{getHarnessError(upgrade.error)}</Typography.Text>
      )}
    </Flex>
  );
};
HarnessUpgradeFeedback.propTypes = {
  upgrade: PropTypes.shape({
    status: PropTypes.string,
    error: PropTypes.string,
    target: PropTypes.shape({ tag: PropTypes.string }),
    progress: PropTypes.shape({
      total: PropTypes.number,
      completed: PropTypes.number,
      pending: PropTypes.number,
      failed: PropTypes.number,
      removed: PropTypes.number,
    }),
  }),
};
export default HarnessUpgradeFeedback;
